import IdleJs from 'idle-js';
import locations from './locations.json';
import destinations from './destinations.json';
import VideoThing from './videoThing';

import './index.scss';

const elem = document.createElement('div');
elem.classList.add('app');
document.querySelector('body').appendChild(elem);

let params = new URLSearchParams(window.location.search);
let startLocation = 'a1';
if (params.get('location') && locations.find((l) => l.id === params.get('location'))) {
  startLocation = params.get('location');
}

const locale = params.get('locale') ? params.get('locale') : 'en';
locations.map((l) => {
  // st translations
  if (l.title) l.title = l.title[locale] || '';
  if (l.buttons) {
    l.buttons.map((b) => {
      b.title = b.title[locale] || '';
      return b;
    });
  }

  return l;
});

const screensaverSettings = {
  disabled: params.get('disableScreensaver') === 'true',
  idleTime: params.get('idleTime') || 20000,
  timeAtLocation: params.get('timeAtLocation') || 10000,
};

const settings = {
  startLocation,
  // assetBase: 'http://localhost:8080',
  buttons: {
    staggerVal: 250,
    transitionDuration: 500,
  },
  transitionOverlay: {
    color: '#fff',
    transitionDuration: 3000,
  },
};
const myVideoThing = new VideoThing(elem, locations, destinations, settings);
let currentLocation = null;

myVideoThing.on('location_reached', (id) => {
  console.info(`You reached location: ${id}`);
  currentLocation = myVideoThing.getLocationById(id);

  params = new URLSearchParams(window.location.search);
  params.set('location', id);
  window.history.replaceState(null, null, `?${params.toString()}`);

  window.parent.postMessage(
    {
      type: 'on_location_reached',
      id,
    },
    '*',
  );
});

myVideoThing.on('location_left', (id) => {
  console.info(`You left location ${id}`);

  window.parent.postMessage(
    {
      type: 'on_location_left',
      id,
    },
    '*',
  );
});

myVideoThing.on('custom_button_clicked', (e, id) => {
  console.info(`You clicked custom button ${id}`);

  window.parent.postMessage(
    {
      type: 'custom_button_clicked',
      id,
    },
    '*',
  );
});

window.addEventListener('message', ({ data }) => {
  switch (data.type) {
    case 'go_to_location':
      myVideoThing.goToLocation(data.id);
      break;
    case 'toggle_button_labels':
      toggleLabels();
      break;
    default:
  }
});

const goToNextLocation = () => {
  const nextLocationId = currentLocation.next_location;
  myVideoThing.goToLocation(nextLocationId);
};

const toggleLabels = () => {
  document.querySelector('#videothing').classList.toggle('show-labels');
};

const showLabels = () => {
  document.querySelector('#videothing').classList.add('show-labels');
};
const hideLabels = () => {
  document.querySelector('#videothing').classList.remove('show-labels');
};

let screensaverInterval = null;
const idle = new IdleJs({
  idle: screensaverSettings.idleTime, // idle time in ms
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
  onIdle() {
    hideLabels();
    goToNextLocation();
    screensaverInterval = setInterval(() => {
      goToNextLocation();
    }, screensaverSettings.timeAtLocation);

    window.parent.postMessage(
      {
        type: 'on_idle',
      },
      '*',
    );
  },
  onActive() {
    clearInterval(screensaverInterval);
  },
  onHide() {
    // callback function to be executed when window become hidden
    clearInterval(screensaverInterval);
  },
  onShow() {
    // callback function to be executed when window become visible
  },
  keepTracking: true, // set it to false if you want to be notified only on the first idleness change
  startAtIdle: false, // set it to true if you want to start in the idle state
});

document.body.addEventListener('click', (event) => {
  const path = event.path || (event.composedPath && event.composedPath());

  if (path.indexOf('.js-arrow-click')) {
    window.parent.postMessage(
      {
        type: 'arrow_button_clicked',
      },
      '*',
    );
  }
});

setTimeout(() => {
  // show labels after first click on arrwow
  let arrowWasClicked = false;
  elem.querySelectorAll('.controls .button').forEach((c) => {
    c.addEventListener('click', () => {
      if (!arrowWasClicked) {
        arrowWasClicked = true;
        setTimeout(() => {
          showLabels();
        }, 500);
      }
    });
  });
}, 500);

if (!screensaverSettings.disabled) {
  idle.start();
}

if (params.get('showLabels') === 'true') {
  showLabels();
}
